import { render } from "./FilterButton.vue?vue&type=template&id=22bc0da8&scoped=true"
import script from "./FilterButton.vue?vue&type=script&lang=js"
export * from "./FilterButton.vue?vue&type=script&lang=js"

import "./FilterButton.vue?vue&type=style&index=0&id=22bc0da8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bc0da8"]])

export default __exports__